import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { context } from './PreviewGroup';
const initialPosition = {
  x: 0,
  y: 0,
};
const Preview = props => {
  const { prefixCls, src, alt, onClose, visible, icons = {}, ...restProps } = props;
  const {
    close,
    left,
    leftDisabled,
    right,
    rightDisabled,
    rotateLeft,
    rotateRight,
    zoomIn,
    zoomOut,
  } = icons;
  const [scale, setScale] = useState(1);
  const [rotate, setRotate] = useState(0);
  const [lastWheelZoomDirection, setLastWheelZoomDirection] = useState({ wheelDirection: 0 });
  const [position, setPosition] = useState(initialPosition);
  const imgRef = useRef();
  const [isMoving, setMoving] = React.useState(false);
  const originPositionRef = React.useRef({ deltaX: 0, deltaY: 0 });
  const {
    isPreviewGroup,
    // registerImage,
    setCurrent,
    // setShowPreview: setGroupShowPreview,
    previewUrls,
    current,
  } = React.useContext(context);
  const previewUrlKeys = Array.from(previewUrls.keys());
  const currentPreviewIndex = previewUrlKeys.indexOf(current);
  const currentPreviewIndexRef = useRef(currentPreviewIndex)
  currentPreviewIndexRef.current = currentPreviewIndex
  const combinationSrc = isPreviewGroup
    ? previewUrls.get(current) && previewUrls.get(current).src
    : src;

  const previewGroupCount = previewUrls.size;
  const showLeftOrRightSwitches = isPreviewGroup && previewGroupCount > 1;
  const handleRestTransform = () => {
    setScale(1);
    setRotate(0);
    setPosition(initialPosition);
  };
  const onSwitchLeft = event => {
    event && event.preventDefault();
    event && event.stopPropagation();
    if (currentPreviewIndexRef.current > 0) {
      // setCurrent(currentPreviewIndex - 1);
      setCurrent(prevCount => { // 通过纯函数进行状态更新
        return prevCount - 1;
      })
      handleRestTransform();
    }
  };
  const onSwitchRight = event => {
    event && event.preventDefault();
    event && event.stopPropagation();
    if (currentPreviewIndexRef.current < previewGroupCount - 1) {
      // setCurrent(currentPreviewIndex + 1);
      setCurrent(prevCount => { // 通过纯函数进行状态更新
        return prevCount + 1;
      })
    
      handleRestTransform();
    }
  };
  const onZoomIn = e => {
    e && e.stopPropagation && e.stopPropagation();
    setScale(value => value + 1);
    setPosition(initialPosition);
  };
  const onZoomOut = e => {
    e && e.stopPropagation && e.stopPropagation();
    if (scale > 1) {
      setScale(value => value - 1);
    }
    setPosition(initialPosition);
  };
  const onRotateLeft = e => {
    e && e.stopPropagation && e.stopPropagation();
    setRotate(value => value - 90);
  };
  const onRotateRight = e => {
    e && e.stopPropagation && e.stopPropagation();
    setRotate(value => value + 90);
  };
  const closeTool = [{ icon: close, onClick: onClose, type: 'close' }];
  const tools = [
    { icon: zoomIn, onClick: onZoomIn, type: 'zoomIn' }, //放大
    { icon: zoomOut, onClick: onZoomOut, type: 'zoomOut', disabled: scale === 1 }, //缩小
    { icon: rotateLeft, onClick: onRotateLeft, type: 'rotateLeft' },
    { icon: rotateRight, onClick: onRotateRight, type: 'rotateRight' },
  ];
  const onWheelMove = e => {
    const wheelDirection = e.deltaY;
    setLastWheelZoomDirection({ wheelDirection });
  };
  useEffect(() => {
    const { wheelDirection } = lastWheelZoomDirection;
    if (wheelDirection > 0) {
      onZoomOut();
    } else if (wheelDirection < 0) {
      onZoomIn();
    }
  }, [lastWheelZoomDirection]);
  const onMouseDown = event => {
    event.preventDefault();
    event.stopPropagation();
    originPositionRef.current.deltaX = event.pageX - position.x;
    originPositionRef.current.deltaY = event.pageY - position.y;
    setMoving(true);
  };
  const onMouseMove = event => {
    event.preventDefault();
    event.stopPropagation();
    if (isMoving) {
      setPosition({
        x: event.pageX - originPositionRef.current.deltaX,
        y: event.pageY - originPositionRef.current.deltaY,
      });
    }
  };
  const onMouseUp = event => {
    event.preventDefault();
    event.stopPropagation();
    if (isMoving) {
      setMoving(false);
    }
  };
  const handlePreventClick = event => {
    event.preventDefault();
    event.stopPropagation();
  };
  const handleKeydownFn = (event) => {
    if (event.keyCode === 27) {
      onClose();
    }
    if (event.keyCode === 37) {
      onSwitchLeft();
    }
    if (event.keyCode === 39) {
      onSwitchRight();
    }
  };
  useEffect(() => {
    if (visible) {
      handleRestTransform();
      window.addEventListener('wheel', onWheelMove, {
        passive: false,
      });
      window.addEventListener('keydown', handleKeydownFn);
      return () => {
        window.removeEventListener('wheel', onWheelMove, {
          passive: false,
        });
        window.removeEventListener('keydown', handleKeydownFn);
      };
    }
  }, [visible]);
  return (
    <div className={cn(`${prefixCls}`, {[`${prefixCls}-auto`]: visible})}>
      {visible && <>
      {closeTool.map(({ icon, onClick, type, disabled }) => (
          <div onClick={onClick} key={type} className={cn(`${prefixCls}-operations-close`)}>
            {icon}
          </div>
        ))}
      <ul className={`${prefixCls}-operations-btns`}>
          {tools.map(({ icon, onClick, type, disabled }) => (
            <li
              onClick={onClick}
              key={type}
              className={cn({ [`${prefixCls}-operations-btn-disabled`]: !!disabled })}>
              {icon}
            </li>
          ))}
      </ul>
      </>}
      <CSSTransition in={visible} timeout={300} classNames={'fade'} unmountOnExit appear>
        <div aria-hidden="true" onClick={onClose} className={`${prefixCls}-wrap`}>
          <img
            src={combinationSrc}
            className={`${prefixCls}-img`}
            style={{
              transform: `translate3d(${position.x}px, ${position.y}px, 0) scale3d(${scale}, ${scale}, 1) rotate(${rotate}deg) `,
            }}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
            ref={imgRef}
            onClick={handlePreventClick}
          />
        </div>
      </CSSTransition>
      {visible && <>
        {showLeftOrRightSwitches && (
          <div className={cn(`${prefixCls}-switch-left`)} onClick={onSwitchLeft}>
            {currentPreviewIndex === 0 ? leftDisabled : left}
          </div>
        )}
        {showLeftOrRightSwitches && (
          <div className={cn(`${prefixCls}-switch-right`)} onClick={onSwitchRight}>
            {currentPreviewIndex === previewGroupCount - 1 ? rightDisabled : right}
          </div>
        )}
      </>}
    </div>
  );
};

export default Preview;



// WEBPACK FOOTER //
// ./src/image/Preview.jsx